import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { Auth } from 'aws-amplify';
import PropTypes from 'prop-types';

import VerificationCodeInput from 'components/inputs/VerificationCode';
import ContactModal from 'components/modals/ContactModal';
import { PrimaryButtonSto, TextButtonSto } from 'components/sto';

import MFAResentModal from './MFAResentModal';

const AccountVerification = (props) => {
    const { setFetchingStatus, setFormField, verificationCode } = props;
    const onVerificationCodeChange = (input) => {
        setFormField('verificationCode', input);
    };
    const [displayResentModal, showResentModal] = useState(false);
    const [displayModal, updateModalVisibility] = useState(false);

    const handleSubmitClick = async (e) => {
        e.preventDefault();
        props.onSubmit({
            verificationCode: verificationCode.value,
        });
    };

    const onModalClosing = () => {
        showResentModal(false);
    };

    const resendCode = async () => {
        setFetchingStatus(true);
        props.setError(null);
        try {
            const authenticatedUser = await Auth.signIn(props.username.value, props.password.value);

            setFetchingStatus(false);

            if (authenticatedUser.challengeParam && authenticatedUser.challengeParam.errorCode) {
                return props.setError('pages.account.verification.too.many.requests');
            }

            showResentModal(true);
        } catch (e) {
            setFetchingStatus(false);
        }
    };

    return (
        <React.Fragment>
            <div className="verification-subtitle">
                <FormattedMessage id="pages.account.verification.subTitle" />
            </div>
            <form onSubmit={handleSubmitClick}>
                <VerificationCodeInput
                    field={verificationCode}
                    onBlur={onVerificationCodeChange}
                    onChange={onVerificationCodeChange}
                />

                <div className="wrapper-button-sto-container">
                    <PrimaryButtonSto
                        disabled={!verificationCode.isValid}
                        labelKey="pages.button.submit"
                        type="submit"
                    />
                </div>

                <div className="pprlpay-link-container">
                    <p>
                        <FormattedMessage id="pages.add.account.resendCode" />
                    </p>
                    <TextButtonSto
                        className="button-link sto-links"
                        id="page-addAccount-verificationCode-button-resendCode"
                        labelKey="pages.add.account.resendCodeLink"
                        onClick={resendCode}
                        style={{ marginBottom: '10px' }}
                        type="button"
                    />
                </div>
                <div className="pprlpay-link-container">
                    <p>
                        <FormattedMessage id="pages.add.account.contactus.text" />
                    </p>
                    <TextButtonSto
                        className="button-link sto-links"
                        id="page-addAccount-button-contactUs"
                        labelKey="pages.registration.links.contactus.text"
                        onClick={() => updateModalVisibility(true)}
                        type="button"
                    />
                </div>
                <ContactModal onOk={() => updateModalVisibility(false)} visible={displayModal} />

                <MFAResentModal email={props.email} onOk={onModalClosing} otpSent visible={displayResentModal} />
            </form>
        </React.Fragment>
    );
};

AccountVerification.propTypes = {
    onSubmit: PropTypes.func.isRequired,
    password: PropTypes.exact({
        errorMessage: PropTypes.string,
        isValid: PropTypes.bool,
        value: PropTypes.string.isRequired,
    }).isRequired,
    setError: PropTypes.func.isRequired,
    setFetchingStatus: PropTypes.func.isRequired,
    setFormField: PropTypes.func.isRequired,
    username: PropTypes.exact({
        errorMessage: PropTypes.string,
        isValid: PropTypes.bool,
        value: PropTypes.string.isRequired,
    }).isRequired,
    verificationCode: PropTypes.exact({
        errorMessage: PropTypes.string,
        isValid: PropTypes.bool,
        value: PropTypes.string.isRequired,
    }).isRequired,
};

export default AccountVerification;
